<template>
  <div class="page">
    <Header title="卡券详情" rightText="兑换卡券" :rightHandler="closeModal"  :leftHandler="onClickLeft" />
    <!-- <div class="select-tab"> -->
      <!-- <div @click="changeSelectTab(0)" :class="{ 'select-tab-active': model.activeIndex === 0 }">线上</div> -->
      <!-- <div @click="changeSelectTab(1)" :class="{ 'select-tab-active': model.activeIndex === 1 }">VIP卡</div> -->
      <!-- <div @click="changeSelectTab(2)" :class="{ 'select-tab-active': model.activeIndex === 2 }">线下</div> -->
    <!-- </div> -->
    <!-- 线上 -->
    <div v-show="model.activeIndex === 0">
      <div class="online-buttons">
        <van-button type="default" round size="normal" v-for="item in onlineTab" :key="item.couponStatus"
          :class="{ 'active': model.onlineActiveIndex === item.couponStatus }"
          @click="clickOnlineButton(item.couponStatus)">
          {{ item.name }}</van-button>
      </div>
      <div class="coupon-list">
        <Coupon v-for="coupon in couponAvailabilityList" :key="coupon.couponId" :coupon="coupon" :model="model"
          @getCouponList="couponList" type="online"></Coupon>
      </div>
      <div class="text-center no-message" v-if="!couponAvailabilityList.length">暂无卡券信息</div>
    </div>
    <!-- VIP卡 -->
    <!-- <div v-show="model.activeIndex === 1">
      <div class="coupon-list">
        <Coupon :vipCardInfo="vipCardInfo" type="vip"></Coupon>
      </div>
      <div class="text-center no-message" v-if="!vipCardInfo">您暂无VIP卡，敬请关注易加网活动！</div>
    </div> -->
    <!-- 线下 -->
    <!-- <div v-show="model.activeIndex === 2">
      <div class="online-buttons">
        <van-button type="default" round size="mini" v-for="item in model.offlineCouponStatusMap" :key="item.key"
          :class="{ 'active': model.subActiveIndexOffline === item.key }" @click="couponTypeOffline(item.key)">
          {{ item.value }}</van-button>
      </div>
      <div class="coupon-list">
        <Coupon v-for="coupon in couponOfflineList" :key="coupon.couponId" :coupon="coupon" :model="model"
          @getCouponList="couponList" type="offline"></Coupon>
      </div>
      <div class="text-center no-message" v-if="!couponOfflineList.length">暂无卡券信息</div>
    </div> -->
    <!-- 兑换卡券弹出层 -->
    <van-popup v-model="popupOption.popupShow" class="popup" round :close-on-click-overlay="false">
      <div class="popup-title">
        <van-icon class="closeIcon" size="0.5rem" name="cross" @click="popupOption.popupShow = false"></van-icon>
        <p class="text-center">兑换卡券</p>
      </div>
      <div class="popup-content">
        <van-field class="green-shadow" v-model="popupOption.code" placeholder="请输入兑换码" clearable />
      </div>
      <van-button plain type="primary" class="popup-button" @click="exchangeCoupon">确定</van-button>
    </van-popup>
  </div>
</template>

<script>
import Header from '@/components/header'
import { userUtils } from '@/utils/auth'
import couponApi from '@/api/coupon'
import Coupon from '@/components/coupon'
// import centerApi from '@/api/center'
export default {
  components: {
    Header,
    Coupon
  },
  data () {
    return {
      model: {
        activeIndex: 0,
        onlineActiveIndex: 0,
        // offlineCouponStatusMap: [], // 线下map
        subActiveIndexOffline: null
      },
      onlineTab: [{
        couponStatus: '02',
        name: '未使用'
      }, {
        couponStatus: '03',
        name: '已使用'
      }, {
        couponStatus: '04',
        name: '已过期'
      }],
      clientInfo: {},
      userType: '',
      // couponOfflineList: [], // 线下卡券列表
      couponAvailabilityList: [], // 线上卡券列表
      // vipCardInfo: null, // vip卡列表
      exchangeShow: false,
      popupOption: {
        popupShow: false,
        title: '请先获取验证码',
        confirmButtonText: '确定删除',
        code: ''
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.clientInfo = userUtils.getClientInfo()
      this.judgeUserChannel()
      this.clickOnlineButton('02')
      // this.queryVipCardInfo()
    },
    // 确认当前用户渠道
    judgeUserChannel () {
      let reg = /^13.*$/
      if (this.clientInfo.channelCode && reg.test(this.clientInfo.channelCode)) {
        // 用户渠道为 13 开头,即汽修厂
        // $scope.model.url = '/api/offline-coupon/workshop/list'
        this.userType = 'workshop'
        // this.getCouponStatusMap('offlineCouponStatusMap')
        // $scope.model.subActiveIndexOffline = '02';
      } else {
        // 用户渠道不是 13 开头,即经销商
        // $scope.model.url = '/api/offline-coupon/wholesaler/list'
        this.userType = 'wholesaler'
        // this.getCouponStatusMap('offlineCouponVerifyStatusMap')
        // $scope.model.subActiveIndexOffline = '0';
      }
      this.couponListOffline('02')
    },
    // 获取线下券map
    // getCouponStatusMap (name) {
    //   let params = {
    //     name: name
    //   }
    //   couponApi.getOfflineCouponVerifyStatusMap(params).then((response) => {
    //     if (response.data.resultCode === '0') {
    //       const { offlineCouponStatusMap, offlineCouponVerifyStatusMap } = response.data.resultData
    //       this.model.offlineCouponStatusMap = offlineCouponStatusMap || offlineCouponVerifyStatusMap
    //       this.model.subActiveIndexOffline = offlineCouponStatusMap[0].key
    //     }
    //   })
    // },
    // 查询线下卡券
    couponListOffline (couponStatus) {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      if (this.userType === 'workshop') {
        if (!couponStatus) {
          couponStatus = '02'
        }
        couponApi.queryWrokshopList({
          couponStatus: couponStatus
        }).then(res => {
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            this.couponOfflineList = res.data.resultData.couponList || []
          }
        })
      } else if (this.userType === 'wholesaler') {
        couponApi.queryOfflineCouponList({
          verifyStatus: couponStatus
        }).then(res => {
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            this.couponOfflineList = res.data.resultData.couponList || []
          }
        })
      } else {
        this.$toast.clear()
      }
    },
    // 线下tab
    couponTypeOffline (couponType) {
      this.model.subActiveIndexOffline = couponType
      this.couponListOffline(couponType)
    },
    // 查询线上卡券
    couponList (couponStatus) {
      const status = couponStatus || this.model.onlineActiveIndex
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      // couponStatus 02未使用，03已使用，04已过期
      couponApi.getCouponList({ couponStatus: status }).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          var couponList = res.data.resultData.couponList || []
          this.couponAvailabilityList = couponList.sort(function (a, b) {
            return (a.couponType - b.couponType)
          })
        }
      })
    },
    // vip
    // queryVipCardInfo () {
    //   centerApi.queryVipCard().then(res => {
    //     if (res.data.resultCode === '0') {
    //       const { vipCardInfo } = res.data.resultData
    //       this.vipCardInfo = vipCardInfo || null
    //     }
    //   })
    // },
    // 线上tab
    clickOnlineButton (couponStatus) {
      this.model.onlineActiveIndex = couponStatus
      this.couponList(couponStatus)
    },
    // 兑换卡券
    exchangeCoupon () {
      if (!this.popupOption.code) {
        this.$toast('兑换码不能为空')
        return
      }
      const data = { giftCode: this.popupOption.code }
      couponApi.exchangeCoupon(data).then(res => {
        if (res.data.resultCode === '0') {
          this.popupOption.popupShow = false
          this.$toast('兑换成功')
          this.activeIndex = 0
          this.clickOnlineButton('02')
        }
      })
    },
    closeModal () {
      this.popupOption.popupShow = true
      this.popupOption.code = ''
    },
    changeSelectTab (type) {
      this.model.activeIndex = type
    },
    onClickLeft () {
      // this.$router.push({
      //   name: 'center'
      // })
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .van-button{
  height: 0.87333rem;
}
/deep/ .van-button--normal{
  padding: 0 0.6rem;
  font-weight: 500;
}

.online-buttons {
  display: flex;
  justify-content: space-around;
  padding: 0.3rem 0rem;
  padding-bottom: 0rem;

  .active {
    color: #f1f1f5;
    border: 1px solid  rgb(17, 114, 129);
    background-color:  rgb(17, 114, 129);

  }
}

.coupon-list {
  padding: 0rem 0.2rem;
}

.popup {
  width: 80%;
  top: 50%;
   background-image: url(../dialog-bg.png);
  background-size: 100%;
  background-repeat: no-repeat;
  .popup-title {
    padding: 0.4rem;
    font-size: 0.5rem;
    color: #fff;
    font-weight: 600;
  }

    .popup-content {
      padding: 0.4rem 0.4rem;

      .van-cell {
        border-radius: 0.2rem;
      }
    }

  .closeIcon {
    position: absolute;
    right: 0px;
    top: 0px;
    padding: 0.2rem;
  }

  .popup-button {
    border: none;
    color: var(--base-green);
    width: 100%;
  }
}

.no-message{
  margin-top: 0.5rem;
}
</style>
